<div class="dealer-information mt-3">
  <div class="row g-0 flex-xl-row flex-column">
    <div class="col-12 col-xl-5 col-xxl-4">
      <div class="info">
        <span *ngIf="dealer != null">{{ dealer.name }}</span>
        <span *ngIf="dealer != null"
          >{{ dealer.streetAddress }}, {{ dealer.postalCode }}</span
        >
        <span *ngIf="dealer != null">{{ dealer.city }}</span>

        <div class="mt-2">
          <i class="fal fa-phone-alt me-1"></i>
          <a [href]="'tel:' + dealer?.phone">{{ dealer?.phone }}</a>
        </div>

        <a
          *ngIf="googleMapsLinkArgs.length > 0"
          [href]="googleMapsLinkArgs | googleMapsLink"
          target="_blank"
          >{{ "dealerInformation.openInGoogleMaps" | translate }}</a
        >
      </div>
    </div>
    <div class="col-12 col-xl-7 col-xxl-8">
      <div class="map">
        <google-map
          [options]="options"
          width="100%"
          height="100%"
          *ngIf="options && marker"
        >
          <map-marker [options]="marker"></map-marker>
        </google-map>
      </div>
    </div>
  </div>
</div>
